// extracted by mini-css-extract-plugin
module.exports = {"timer":"_1159","item":"_17364","divider":"_18259"};